import React from "react";
import "./Footer.css";

const AdminFooter = () => {
  // get current malaysia year
  const getCurrentYear = () => {
    const malaysiaTime = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Kuala_Lumpur",
    });
    return new Date(malaysiaTime).getFullYear();
  };

  return (
    <footer className="adminFooter">
      Bodyfriend Admin Dashboard © {getCurrentYear()}
    </footer>
  );
};

export default AdminFooter;
